import React from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TablePaginationActions from '../../shared/components/Table/Actions';
import Button from '@mui/material/Button';
import { dateFormat, timeFormat } from '../../util/DateUtil';
import Loading from '../UI/Loading';
import { CircularProgress, Grid, Tooltip } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import PresencaTableFilter from './PresencaTableFilter';

const useStyles = makeStyles({
    paper: {
        marginTop: '20px'
    },
    table: {
        minWidth: 650,
    },
    title: {
        paddingTop: '20px',
        margin: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    submit: {
        marginRight: '8px',
    },
    loadingRemove: {
        marginRight: '10px',
        marginLeft: '10px'
    }
});


export default function PresencaTable({
    presencas,
    tdp,
    isLoading,
    isLoadingRemove,
    handleDelete,
    handleDuplicarPresenca,
    handleChangePage,
    setPresenca,
    showFilters,
    setShowFilters,
    mesSelect,
    setMesSelect,
}) {
    const classes = useStyles();


    return (
        <div>
            <Grid container spacing={3} direction='column'>
                <Grid>
                    <Grid container spacing={3} direction='row'>

                        <Grid>
                            <Button
                                className={classes.novoRegistro}
                                onClick={() => setPresenca({ tdp: tdp, eNovo: true })}
                                variant="contained"
                                color="primary">
                                Nova Presença
                            </Button>
                        </Grid>
                        <Grid>
                            <Tooltip title="Filtrar">
                                <Button
                                    variant={showFilters ? 'contained' : 'outlined'}
                                    onClick={() => setShowFilters((prevState) => (!prevState))}
                                >
                                    <FilterListIcon />
                                </Button>
                            </Tooltip>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid>
                    {showFilters ?
                        <PresencaTableFilter
                            mesSelect={mesSelect}
                            setMesSelect={setMesSelect}
                        /> :
                        ''}
                </Grid>

            </Grid>
            {isLoading ? <Loading description="Carregando Presenças..." /> :
                <>
                    <TablePagination
                        rowsPerPageOptions={[]}
                        rowsPerPage={presencas.size ? presencas.size : 0}
                        component="div"
                        count={presencas.totalElements}
                        page={presencas.number}
                        onPageChange={handleChangePage}
                        labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                        ActionsComponent={TablePaginationActions}
                    />
                    <Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: "350px" }}>Conteúdo</TableCell>
                                <TableCell>Data</TableCell>
                                <TableCell>Cronograma Aula</TableCell>
                                <TableCell >Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {presencas.content.map((presenca, index) => (
                                <TableRow key={presenca.codigo}>
                                    <TableCell>{presenca.conteudo}</TableCell>
                                    <TableCell>{dateFormat(presenca.data)}</TableCell>
                                    <TableCell>{presenca.cronograma && "Aula " + presenca.cronograma.cronogramaAula.ordemAula + " : " + timeFormat(presenca.cronograma.cronogramaAula.horarioInicio) + " - " + timeFormat(presenca.cronograma.cronogramaAula.horarioFim)}</TableCell>
                                    <TableCell>
                                        <EditIcon
                                            fontSize='small'
                                            color="secondary"
                                            style={{ marginRight: '10px' }}
                                            className={classes.cursorLink}
                                            onClick={() => setPresenca(presenca)}
                                        />
                                        {isLoadingRemove ?
                                            <CircularProgress
                                                className={classes.loadingRemove}
                                                color="secondary"
                                                size={20}
                                            /> :
                                            <DeleteIcon
                                                fontSize='small'
                                                className={classes.cursorLink}
                                                onClick={() => { handleDelete(presenca.codigo) }}
                                                style={{ marginRight: '10px' }}
                                                color="secondary"
                                            />
                                        }
                                        {/* <Button
                                            component={Link}
                                            to={{
                                                pathname: '/presenca-aluno',
                                                state: {
                                                    presenca: presenca
                                                }
                                            }}
                                            type="button"
                                            variant="contained"
                                            size='small'
                                            color="secondary"
                                            onClick={() => {
                                                setPresenca(presenca);
                                            }}
                                            className={classes.submit}>
                                            Presença Aluno
                                        </Button> */}
                                        <Button
                                            type="button"
                                            variant="contained"
                                            size='small'
                                            color="secondary"
                                            onClick={() => { handleDuplicarPresenca(index) }}
                                            className={classes.submit}>
                                            Duplicar Presença
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[]}
                        rowsPerPage={presencas.size ? presencas.size : 0}
                        component="div"
                        count={presencas.totalElements}
                        page={presencas.number}
                        onPageChange={handleChangePage}
                        labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                        ActionsComponent={TablePaginationActions}
                    />
                </>
            }
        </div>
    );
}